import styled from 'styled-components';
import { helpTextDanger } from 'styles/variables';
import { placeholderTextDefault } from 'styles/variables/colors';

export const InputWrapper = styled.input<{ hasError: boolean }>`
  background-clip: padding-box;
  background-color: #fff;
  border: 1px solid ${({ hasError }) => (hasError ? helpTextDanger : '#bfbfbf')};
  border-radius: 4px;
  color: ${placeholderTextDefault};
  display: block;
  font-size: ${({ theme }) =>
    theme.configs?.styling?.searchForm?.inputFontSize || 14}px;
  font-weight: 400;
  height: ${({ theme }) =>
    theme.configs?.styling?.searchForm?.inputHeight || 40}px;
  line-height: 1.2;
  padding: 0.375rem 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;

  ::placeholder {
    color: ${placeholderTextDefault};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 2rem;
`;
